import PropTypes from "prop-types";

import LinksList from "@/components/Elements/LinksList";

import { AssetTypeType } from "./AssetType.type";

const AssetTypesLinksList = ({ assetTypes }) => {
  const links = assetTypes?.map(({ id, name }) => ({
    label: name,
    to: `/asset-types/${id}`,
  }));

  return <LinksList links={links} />;
};

AssetTypesLinksList.propTypes = {
  assetTypes: PropTypes.arrayOf(AssetTypeType),
};

export default AssetTypesLinksList;
